import {BaseObject} from "@/common/BaseObject";
import {alias, createModelSchema, custom, deserialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class MapGroupModel extends BaseObject {
    constructor(key = "", code = null) {
        super();

        this._key = key;
        this._code = code;
    }

    static schema() {
        return custom(
          (v) => {
              return v && v.key ? v.key : SKIP;
          },

          v => {
              if (typeof v === 'string') {
                  return RedactorUtils.getMapGroupByKey(v);
              } else if (typeof v === 'object' && v !== null) {
                  return deserialize(MapGroupModel, v);
              } else {
                  return null;
              }
          }
        );
    }

    static isNone(value) {
        return (
          value instanceof MapGroupModel &&
          (value.code === 0 || value.key === "none")
        );
    }

    static getNone(items) {
        return items.find(
          item => item && (item.code === 0 || item.key === "none")
        ) || null;
    }
    
    static isGlobal(value) {
        return (
          value instanceof MapGroupModel &&
          (value.code === 1 || value.key === "map_group_global")
        );
    }

    static isMain(value) {
        return (
          value instanceof MapGroupModel &&
          (value.code === 2 || value.key === "map_group_main")
        );
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get code() {
        return this._code;
    }

    set code(value) {
        this._code = value;
    }

    valid() {
        if (typeof this.key !== "string" || !this.key.trim()) {
            return false;
        }

        if (!Number.isInteger(this.code) || this.code < 0) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MapGroupModel());
        } else if (target instanceof MapGroupModel) {
            return super.clone(target);
        } else {
            console.log(false);
            return undefined;
        }
    }

    empty() {
        return typeof this.key !== 'string' || this.key.trim() === '';
    }
}

createModelSchema(MapGroupModel, {
    _key: alias("key", Schema.primitive()),
    _code: alias("code", Schema.number()),
});